export default __webpack_public_path__ + "static/media/kaci-baum-2.14af8c56.jpg";